<template>
  <div id="app" class="bg-gradient-to-br from-primary to-primary-light text-base">
    <!-- If the username isn't set, show input form -->
    <div v-if="!gameStarted" class="min-h-[100svh] flex items-center justify-center">
      <div class="card max-h-[70vh] max-w-[550px] w-full overflow-auto mx-3">
        <ConnectScreen v-if="!connected"/>
        <div v-else>
          <GameMode v-if="invitationAccepted"
                    :socket="socket"
                    :game-players="players"
                    :current-user-id="socket.id"/>
          <div v-else>
            <PlayerRegister
                v-if="!isRegistered"
                @setUsername="setUsername"/>
            <PlayerLobby
                v-else
                :socket="socket"
                :active-users="activeUsers"
                :current-user-id="socket.id"
                :current-username="username"
                @inviteBot="inviteBot"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- If the username is set, show the active users list and PlayerLobby -->
    <div v-if="gameStarted">
      <CricketGame v-if="gameSettings.gameMode === 'Cricket'" :game-players="players" :game-settings="gameSettings" :this-user-id="socket.id" :socket="socket"/>
    </div>
  </div>
</template>

<script>
import {io} from "socket.io-client";
import ConnectScreen from "./components/ConnectScreen.vue";
import GameMode from "./components/GameMode.vue";
import PlayerRegister from "./components/PlayerRegister.vue";
import PlayerLobby from "./components/PlayerLobby.vue";
import CricketGame from "./components/CricketGame.vue";

export default {
  name: "App",
  components: {
    ConnectScreen,
    GameMode,
    PlayerRegister,
    PlayerLobby,
    CricketGame,
  },
  data() {
    return {
      connected: false,
      socket: null,
      activeUsers: [], // [{ id: socketId, name: username }]
      username: "",
      isRegistered: false,
      invitationAccepted: false,
      gameStarted: false,
      gameSettings: [],
      players: [],
    };
  },
  computed: {
    thisUser() {
      return this.activeUsers.find(user => user.id === this.socket?.id) || {};
    }
  },
  mounted() {
    // Connect to the server
    this.socket = io(process.env.VUE_APP_BACK_END_URL);
    console.log(`API url: ${process.env.VUE_APP_BACK_END_URL}`);

    this.socket.on("connect", () => {
      this.connected = true;
      console.log("Connected to server with ID:", this.socket.id);
    });

    this.socket.on("connect_error", () => {
      this.$showToast(`Error connecting to the server ⚠️`, false);
    });

    // Listen for the list of active users
    this.socket.on("activeUsers", (users) => {
      this.activeUsers = users; // Users will now be an array of { id, name }
    });

    // Listen for the invitation accepted event
    this.socket.on("invitationAccepted", (data) => {
      console.log("Invitation accepted:", data);
      this.players = data.players;
      this.invitationAccepted = true;

      this.$showToast(data.message);
    });

    this.socket.on("startGame", (data) => {
      console.log("startGame:", data);
      this.gameSettings = data.settings;
      this.gameStarted = true;

      this.$showToast(data.message);
    });
  },
  methods: {
    setUsername(username) {
      this.username = username;
      this.registerUser();
    },
    inviteBot() {
      this.invitationAccepted = true;
      this.players = [{id: this.thisUser?.id, name: this.thisUser?.name, inviter: true }, {id: 0, name: 'Offline Bot', inviter: false, bot: true}];
    },
    registerUser() {
      if (this.username && this.socket) {
        console.log(`Registering username: ${this.username}`);
        this.socket.emit("register", this.username);
        this.isRegistered = true;

        this.$showToast(`You are now registered 🥳`);
      }
    },
  },
};
</script>
